import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';
import { Link } from 'react-router-dom';
import TreatmentIntroBanner from '../../../components/treatmentBanner/treatmentBanner';

const SculptraPage = () => {
	const prices = [{ label: 'Treatment', value: '€600/£408' }];

	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<TreatmentIntroBanner
								title="Sculptra"
								description="Sculptra is a collagen stimulator using poly-L-lactic acid (PLLA) to gradually restore facial volume, improve skin texture, and lift sagging areas with long-lasting, natural-looking results."
								quote=" Regenerate your beauty from the inside out. "
								backgroundImage="/assets/images/banners/treatment-xl-2.png"
							/>

							<div className="section mcb-section" id="image" style={{ paddingBottom: '70px' }}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-third column_image">
												<div className="image_frame image_item scale-with-grid aligncenter has_border hrmargin_b_30">
													<div className="image_wrapper">
														<div className="mask"></div>
														<img
															className="scale-with-grid"
															src="/assets/images/treatments/sculptra.jpg"
															alt="Skin Consultation"
															width="960"
															height="960"
														/>
													</div>
												</div>
											</div>
											<div className="column mcb-column two-third column_column">
												<div className="column_attr clearfix">
													<h4>What to Expect</h4>
													<ul>
														<li>Treatment typically lasts under an hour and is performed in-clinic.</li>
														<li>Gradual improvement begins after the first few weeks and builds over a few months.</li>
														<li>Minimal downtime with mild swelling or redness that usually resolves quickly.</li>
														<li>Recommended treatment plan includes a series of sessions for long-term collagen renewal.</li>
													</ul>

													<h4>Treatment Areas & Benefits</h4>
													<p>Sculptra is ideal for:</p>
													<ul>
														<li>Restoring facial volume in cheeks, temples, and jawline.</li>
														<li>Smoothing deep lines and folds, such as nasolabial and marionette lines.</li>
														<li>Stimulating collagen to improve skin texture, firmness, and natural glow.</li>
													</ul>

													<h4>Why Choose Sculptra?</h4>
													<ul>
														<li>Non-surgical approach to deep facial rejuvenation.</li>
														<li>Results develop subtly over time, appearing natural and progressive.</li>
														<li>Effectively rebuilds collagen and improves long-term skin integrity.</li>
													</ul>
												</div>
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>

															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	{prices.map(({ label, value }, idx) => (
																		<li key={idx} className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																			<div>
																				<strong>{label}</strong>
																			</div>
																			<div style={{ whiteSpace: 'pre-line' }}>{value}</div>
																		</li>
																	))}
																</ul>
																<hr className="bg-theme" />
															</div>

															<div className="plan-footer">
																<Link to="/book-now" className="button button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="column one column_slider">
												<div className="column_attr clearfix hrmargin_b_60">
													<h2
														className="hrmargin_b_60"
														style={{
															textAlign: 'center',
														}}>
														Results
													</h2>

													<div className="content_slider">
														<ul className="content_slider_ul">
															<li className="content_slider_li_1">
																<img
																	width="100%"
																	height="auto"
																	src="/assets/images/treatments/sculptra-result.jpg"
																	alt="Sculptra before and after"
																	className="scale-with-grid wp-post-image"
																/>
															</li>
														</ul>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>
											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<h2
														className="hrmargin_b_60"
														style={{
															textAlign: 'center',
														}}>
														After-Care
													</h2>
													<ul>
														<li>
															Massage the treated areas gently for several days using clean hands, following practitioner guidance
															closely.
														</li>
														<li>
															Avoid strenuous activity, excessive heat, or pressure on the area for a few days post-treatment to
															support optimal healing.
														</li>
														<li>
															Use mild, hydrating skincare and avoid active ingredients such as retinoids or exfoliants for at
															least one week.
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default SculptraPage;
